module.exports = __webpack_public_path__ + "img/26.8c7ed69b.png";